import { Location } from '@angular/common';
import { AfterContentInit, Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { db } from 'src/app/db/db';
import { MeasureGeneric } from 'src/app/domain/measure-generic';
import { EditTextBoxDialog } from 'src/app/tools/ui/edit-text-box/edit-text-box';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';

@Component({
  selector: 'app-generics',
  standalone: false,
  templateUrl: './generics.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './generics.component.scss'
})
export class GenericsComponent implements OnInit, AfterContentInit {
    Model: MeasureGeneric = new MeasureGeneric();
    mrCode: string | undefined;

    constructor(
        private location: Location,
        private snackBar: MatSnackBar,
        private dialog: MatDialog,
        private route: ActivatedRoute) {

    }

    ngOnInit(): void {
        this.mrCode = this.route.snapshot.params?.['code'];
    }

    async ngAfterContentInit(): Promise<void> {
        if (!this.mrCode)
            return;
        this.Model = await db.getMesureGenericByCode(this.mrCode);
    }

    cancelMeasure() {
        const dialogRef = this.dialog.open(EditTextBoxDialog, { data: { title: 'Veuillez indiquer le motif de l\'annulation', withCancelButton: true } });
        dialogRef.afterClosed().subscribe(async (result: string) => {
            if (result) {
                // TODO delete in DB
                await db.cancelGeneric(this.Model, result);
                NotificationManager.handleSuccess('Mesure annulée', this.snackBar);
                this.location.back()
            }
        })
    }

    async save() {
        const success = await db.updateMeasureGeneric(this.Model);
        if (success) {
            NotificationManager.handleSuccess('Mesure enregistrée', this.snackBar);
            this.location.back()
        } else if (!success) {
            NotificationManager.handleError('Wasted Bro!', this.snackBar);
        }
    }
}
